import { render, staticRenderFns } from "./MaxiPuntos.vue?vue&type=template&id=547c0390&scoped=true"
import script from "./MaxiPuntos.vue?vue&type=script&lang=js"
export * from "./MaxiPuntos.vue?vue&type=script&lang=js"
import style0 from "./MaxiPuntos.vue?vue&type=style&index=0&id=547c0390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547c0390",
  null
  
)

export default component.exports